// @flow
import type { Element, Node } from 'React';

import React from 'react';
import { FormGroup as Group } from 'reactstrap';

/* eslint-disable react/jsx-props-no-spreading */
type Props = {|
  children: Node,
  row?: boolean,
  check?: boolean,
  inline?: boolean,
  disabled?: boolean,
  tag?: string,
  className?: string,
  cssModule?: Object,
  visible: boolean,
|};

const EnhancedFormGroup = ({
  row = false,
  check = false,
  inline = false,
  disabled = false,
  tag = 'div',
  className = '',
  cssModule = {},
  visible,
  children,
  ...rest
}: Props): Element<typeof Group> | null => {
  if (visible === false) {
    return null;
  }
  return (
    <Group
      row={row}
      check={check}
      inline={inline}
      disabled={disabled}
      tag={tag}
      className={className}
      cssModule={cssModule}
      {...rest}
    >
      {children}
    </Group>
  );
};

export default EnhancedFormGroup;
